module.exports = __webpack_public_path__ + "img/ramon.6e3ccbcd.jpeg";